import { render, staticRenderFns } from "./DuplicateDeliverableDetail.vue?vue&type=template&id=1ec7df72&scoped=true&"
import script from "./DuplicateDeliverableDetail.vue?vue&type=script&lang=js&"
export * from "./DuplicateDeliverableDetail.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateDeliverableDetail.vue?vue&type=style&index=0&id=1ec7df72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec7df72",
  null
  
)

export default component.exports